"use strict";

/* Controllers */

angular
    .module("BannerFlowApp")
    .controller(
        "LandingPagesController",
        function ListController(
            $controller,
            $scope,
            $rootScope,
            LandingPage,
            AuthInfo,
            $state,
            Utils,
            History
        ) {
            document.title = "Bannerflow - Landing Pages";

            $scope.urlParams = $state.params;

            $controller("ListController", { $scope: $scope });

            $scope.listModel.type = $rootScope.OBJECT_TYPE_LANDINGPAGE;
            $scope.listModel.resource = LandingPage;

            $scope.model = {
                loading: false,
                landingPageName: "",
                user: {
                    isEmployee: AuthInfo.LoggedInUser.isEmployee
                }
            };

            $scope.loadStatus = function (landingPage) {
                if (landingPage.isFolder || landingPage.status || !landingPage.externalId) return;

                LandingPage.status(
                    {
                        id: landingPage.externalId
                    },
                    function (response) {
                        landingPage.status = response.data;
                    },
                    function (response) {
                        if (response && response.data && response.data.message)
                            console.error("SERVER MESSAGE:", response.data.message);
                    }
                );
            };

            $scope.addLandingPage = function () {
                if (!$scope.model.landingPageName) return;

                $scope.listModel.addItemLoading = true;

                var landingPage = new LandingPage();
                landingPage.name = $scope.model.landingPageName;
                landingPage.folder = $state.params.folderId || null;

                landingPage.$create(function (data) {
                    window.location = data.url;
                });
            };

            $scope.publish = function () {
                $scope.listModel.selection.items.forEach(function (item, index) {
                    LandingPage.publish(
                        { id: item.id, force: true },
                        function () {
                            item.status = $rootScope.LANDINGPAGE_STATUS_PUBLISHED;
                        },
                        function (response) {
                            console.error("Publish landing page '" + item.name + "' failed.");

                            if (response && response.data && response.data.message)
                                console.error("SERVER MESSAGE:", response.data.message);
                        }
                    );
                });
            };

            $scope.navigateToOpenView = function (lp, event) {
                Utils.GotoV2Url(
                    "landingpages/" + lp.slug,
                    event.which == 2 || event.button == 4 || event.ctrlKey || event.metaKey
                );
            };

            History.SetLastVisitedBrand("LandingPages");
        }
    );
